import '../styles/ODS.css';
import cardsData from "../assets/info/cards-ods.json";
import React, { useState } from "react";
import Card from "./Card";
import { odsImages } from '../functions/general';

const ODS = () => {

  const [selectedCard, setSelectedCard] = useState(null);

  const handleClick = (key) => {
    setSelectedCard(cardsData[key]);
  };

  const handleClose = () => {
    setSelectedCard(null);
  };

  return (
    <div className="ods-container">
      {odsImages.map((image, index) => (
        <img
          className={`imagen ${index === odsImages.length - 1 ? "no-hover" : ""}`}
          key={index}
          src={require(`../assets/imagenes/ods/${image.src}.jpg`)}
          alt={image.alt}
          onClick={() => handleClick(image.key)}
        />
      ))}


      {
        selectedCard && (
          <div className="overlay" onClick={handleClose}>
            <Card
              title={selectedCard.title}
              color={selectedCard.color}
              image={selectedCard.image}
              link={selectedCard.link}
              description={selectedCard.description}
            />
          </div>
        )
      }
    </div>
  );
};

export default ODS;